import UpgradeFreePlanModal from '@/components/Modals/UpgradeFreePlanModal';
import { TranslationBanner } from '@/pages/translation/components/TranslationBanner';
import { TranslationLibrary } from '@/pages/translation/components/TranslationLibrary';
import { useAuth } from '@/services/auth';
import { useGetTranslationGroups, useTranslationsGroupNotifications } from '@/state/translations';
import styled from '@emotion/styled';
import { CreateTranslationModal } from './components/CreateTranslationModal';
import { Header } from './components/Header';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const TranslationLibraryPage = () => {
    const { isAnonymous } = useAuth();
    const { data, isLoading, hasNextPage, fetchNextPage, isFetchingNextPage } = useGetTranslationGroups(isAnonymous);

    useTranslationsGroupNotifications();

    const isFirstTimeUser = !isLoading && !data?.groups?.length;

    return (
        <Container>
            <Header />
            <TranslationBanner show={isFirstTimeUser} />
            <TranslationLibrary
                data={data}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
                isFetchingNextPage={isFetchingNextPage}
            />
            <CreateTranslationModal />
            <UpgradeFreePlanModal from="translation-library" />
        </Container>
    );
};
